export function getMonthDateGrids(dateRange, expanded) {
  // Group dates by month
  const monthMap = dateRange.reduce((acc, date) => {
    const month = new Date(date).toLocaleString('en-US', { month: 'short' }).toUpperCase();
    if (!acc[month]) acc[month] = [];
    acc[month].push(date);
    return acc;
  }, {});

  // If not expanded, only show the first month
  const entries = expanded
    ? Object.entries(monthMap)
    : Object.entries(monthMap).slice(0, 1);

  // Build week grids for each month
  return entries.map(([month, dates]) => {
    const firstDate = new Date(dates[0]);
    const firstDayIdx = firstDate.getDay();
    const daysInMonth = dates.length;
    const weeks = [];
    let week = new Array(7).fill(null);
    let dateIdx = 0;
    for (let i = firstDayIdx; i < 7 && dateIdx < daysInMonth; i++) {
      week[i] = dates[dateIdx++];
    }
    weeks.push(week);
    while (dateIdx < daysInMonth) {
      week = new Array(7).fill(null);
      for (let i = 0; i < 7 && dateIdx < daysInMonth; i++) {
        week[i] = dates[dateIdx++];
      }
      weeks.push(week);
    }
    return { month, weeks, dates };
  });
}
